import { RootState } from '@spa/lib/store/RootState';
import { StateWishlist } from '@spa/lib/store/wishlists/WishlistsState';

const selectWishlists = ({ wishlists: { wishlists } }: RootState): ReadonlyArray<StateWishlist> =>
  wishlists;

export default selectWishlists;
